import getSliceName from '@om-fe/core/utils/get-slice-name';
import { DisciplinesType } from '@om-fe/models';
import {
    TOP_BETS_TIME_RANGE_PATH,
    TOP_BETS_TIME_RANGE_LOCATION_PATH,
    TOP_BETS_TIME_RANGE_CATEGORY_PATH,
    TopBetsTimeRangeTopic,
    slicePrefix,
} from './top-bets.constants';

export function getTopBetsTimeRangeSliceName(instanceId: string): string {
    return getSliceName(`${slicePrefix}-Time-Range`, instanceId);
}

export const TOP_BETS_STORAGE_KEY: string = 'omfe:topBets';

export interface TopBetsRouteParams {
    readonly sportRoute?: string;
    readonly locationRoute?: string;
    readonly timeRoute?: string;
}

export function getTopBetsTimeRangeTopic(
    disciplineId: string,
    locationId?: string,
    categoryId?: string,
): TopBetsTimeRangeTopic {
    const timezoneOffset = (new Date()).getTimezoneOffset();

    if (disciplineId === DisciplinesType.ElectronicSports && locationId) {
        return {
            path: TOP_BETS_TIME_RANGE_PATH,
            params: {
                disciplineId: locationId,
                offsetTime: timezoneOffset,
            },
        };
    } else {
        if (categoryId) {
            return {
                path: TOP_BETS_TIME_RANGE_CATEGORY_PATH,
                params: {
                    disciplineId,
                    offsetTime: timezoneOffset,
                    categoryId,
                },
            };
        } else if (locationId) {
            return {
                path: TOP_BETS_TIME_RANGE_LOCATION_PATH,
                params: {
                    disciplineId,
                    offsetTime: timezoneOffset,
                    locationId,
                },
            };
        } else {
            return {
                path: TOP_BETS_TIME_RANGE_PATH,
                params: {
                    disciplineId,
                    offsetTime: timezoneOffset,
                },
            };
        }
    }
}

export interface TopBetsStorageData {
    readonly sportId?: string;
    readonly locationId?: string;
    readonly timeRangeId?: string;
}